import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Button, Image, Toast } from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import {
  faCheckCircle,
  faTimesOctagon,
} from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "..";
import {
  manageMapperStore,
  setManageMapperFlow,
  getProfileDetailsAction,
  setManageCensusToastInfo,
  manageDistributionStore,
  setManageDistributionToastInfo,
  saveRequest,
  uploadLoanDocuments,
  saveInProgressLoan,
} from "../../contexts";
import { LoaderWrapper } from "..";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  MANAGE_MAPPER_ROUTES,
  ROUTES,
  FLOW_TYPES,
  manageMapperFormNames,
  apiErrors,
  getPathWithParam,
  getAdvancedPathWithParam,
  ALL_MANAGE_MAPPER_ROUTES,
  MANAGE_CENSUS_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
} from "../../utils";
import { useFormikContext } from "formik";
import Cancel from "../../styles/cancel.png";
import { saveInProgressLoanRequest } from "../../services";
import { uploadLoanDocumentsRequest } from "../../services/withdrawal";
import RouteLeavingGuard from "../RouteLeavingGuard";
import GetInitials from "../GetInitials";
import SaveDraftSection from "../SaveDraftSection";
import { MANAGE_TRANSACTION_ROUTES } from "../../utils/constants/transaction";

import payrollFrequency from "./../../mocks/payrollFrequency.json";

const ManageDistributionLayout = ({
  rptName,
  children,
  buttonStatus,
  buttons = [],
  tabs,
  pageFlow,
  status,
  layoutHeader,
  customBreadCrumbs,
  history,
  donotShowBreadcrumbs,
  values,
  employeeImage,
  planId,
  withdrawalId,
  isWithdrawalRequest,
  isWithdrawalSummary,
  blockNavigation = false,
  isLoanRequest,
  isLoanSummary = false,
  withdrawalRequestId,
  setSelectPlanError,
  loanSettingId,
  loanRequestId,
}) => {
  const [showError, setShowError] = useState(false);
  const { state, dispatch } = useContext(manageDistributionStore);
  const reportName = get(
    state,
    `${manageMapperFormNames.ELIGIBILITY_FILTER}.reportName`
  );
  const {
    censusId,
    flow,
    withdrawalRequestIdFormURL,
    fromPage,
  } = useRouterParams();
  const { showToast, toastMessage } = state;
  const [dataLoading, setDataLoading] = useState(false);
  const apiError = get(state, "api.error", {});
  const apiData = get(state, "api.data", {});
  const {
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
  } = useFormikContext() || { dirty: false };

  const onRefresh = () => {
    if (resetForm) {
      resetForm();
      setSubmitting(false);
    }
  };

  const menuDetails = find(ALL_MANAGE_MAPPER_ROUTES, (item) => {
    if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
      return true;
    }
    return false;
  });

  // useDeepEffect(() => {
  //   if (isEmpty(apiData) && censusId) {
  //     setDataLoading(true);
  //     dispatch(
  //       getProfileDetailsAction(censusId, dispatch, state).then((res) => {
  //         setDataLoading(false);
  //       })
  //     );
  //     dispatch(setManageMapperFlow({ flow, censusId }));
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [censusId]);

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const breadCrumOptions = [
    {
      label: "Home",
      link: ROUTES.HOME,
    },
    {
      label: "Manage Employees",
      link: ROUTES.MANAGE_EMPLOYEE,
    },
  ];

  if (reportName) {
    breadCrumOptions.push({
      label: reportName,
      link: getPathWithParam({
        path: MANAGE_MAPPER_ROUTES.MAP_AND_TRANSFORM,
        pathParam: [flow],
      }),
    });
  }

  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  }
  const breadCrumbsFromMenuDetails = get(menuDetails, "breadCrumbs", []);
  if (!isEmpty(customBreadCrumbs)) {
    breadCrumOptions.push(...customBreadCrumbs);
  } else if (!isEmpty(breadCrumbsFromMenuDetails)) {
    breadCrumOptions.push(
      ...breadCrumbsFromMenuDetails.map((item) => ({
        ...item,
        link: getPathWithParam({
          path: item.link,
          pathParam: [flow],
        }),
      }))
    );
  }

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];

  let payload = {
    id: withdrawalRequestId ? withdrawalRequestId : 0,
    employeeId: parseInt(censusId),
    planId: values?.planId,
    withdrawEntireAmount: values?.withdrawEntireAmount
      ? values?.withdrawEntireAmount
      : 0,
    withdrawalId: withdrawalId,
    userId: 1,
    withdrawalStatus: 1,
    withdrawalType: values?.withdrawalType,
    withdrawalTransactions: values?.distribution,
    isDraft: true,
  };

  const CancelButton = () => {
    if (isWithdrawalRequest) {
      setSubmitting(true);
      if (values.planId && values.withdrawalType) {
        saveRequest(payload, dispatch)
          .then((response) => {
            if (response) {
              history.push(
                fromPage == 4
                  ? getPathWithParam({
                      path: MANAGE_TRANSACTION_ROUTES.DRAFT,
                    })
                  : getPathWithParam({
                      path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                      pathParam: [flow, censusId],
                    })
              );
            } else {
              setSubmitting(false);
            }
          })
          .catch(() => {
            setSubmitting(false);
          });
      } else {
        setSelectPlanError("* RI024 : Required");
      }
    } else if (isLoanRequest) {
      const loanRequestValues = {
        employeeId: censusId,
        id: loanRequestId,
        loanType: get(values, "loanTypeDescription", null),
        // employeeId: 1,
        planId: get(values, "planID"),
        loanSettingId: loanSettingId,
        loanFeeType: get(values, ""),
        reasonForLoan: get(values, "loanReason"),
        interestRate: get(values, "interestRate"),
        requestedAmount: get(values, "requestedAmount"),
        periodicPaymentAmount: get(values, "periodicPayment"),
        tenureYears: get(values, "tenureYears"),
        tenureMonths: get(values, "tenureMonths"),
        paymentMethod: get(values, "paymentOption"),
        repaymentMethod: get(values, "repaymentMethod"),
        firstRepaymentDate: get(values, "firstRepaymentDate"),
        repaymentFrequency:
          get(values, "repaymentFrequency") != null
            ? payrollFrequency.data.find(
                (_) => _.label == get(values, "repaymentFrequency")
              )?.value
            : null,
        repaymentBankDetail: [1, 3].includes(get(values, "repaymentMethod"))
          ? {
              nameOfFinancialInstitution: get(
                values,
                `repaymentBankDetail.nameOfTheFinancialInstitution`,
                ""
              ),
              routingNumber: get(
                values,
                `repaymentBankDetail.abaRoutingNumberforBankOfCreditUnion`
              ),
              typeOfAccount: get(values, `repaymentBankDetail.typeOfAccount`),
              accountNumber: get(
                values,
                `repaymentBankDetail.checkingSavingsAccountNumber`
              ),
              accountHolderName: get(
                values,
                `repaymentBankDetail.accountHolderName`
              ),
            }
          : null,
        eft:
          get(values, "paymentOption") === 2
            ? {
                nameOfFinancialInstitution: get(
                  values,
                  `bank.nameOfTheFinancialInstitution`,
                  ""
                ),
                routingNumber: get(
                  values,
                  `bank.abaRoutingNumberforBankOfCreditUnion`
                ),
                typeOfAccount: get(values, `bank.typeOfAccount`),
                accountNumber: get(values, `bank.checkingSavingsAccountNumber`),
                accountHolderName: get(values, `bank.accountHolderName`),
              }
            : null,

        cheque:
          get(values, "paymentOption") === 1
            ? {
                checkPayableTo: get(values, `address.checkPayableTo`),
                sendPaymentTo: null,
                address: {
                  address1: get(values, `address.address1`),
                  address2: get(values, `address.address2`),
                  address3: get(values, `address.address3`),
                  // country: get(values, `address.country`),
                  // state: get(values, `address.state`),
                  city: get(values, `address.city`),
                  zipCode: get(values, `address.zipCode`),
                  countryId: get(values, `address.countryId`),
                  stateId: get(values, `address.stateId`),
                  foreignCountry: get(values, `address.foreignCountry`),
                  foreignState: get(values, `address.foreignState`),
                  foreignZipCode: get(values, `address.foreignZipCode`),
                },
              }
            : null,
        overnightDelivery: get(values, "overnightDelivery"),
        employeeAuthorization: get(values, ""),
        loanActivationDate: get(values, ""),
        loanRequestDate: get(values, "loanRequestDate"),
        loanStatus: get(values, "loanStatus", 1),
        chequeFees:
          get(values, "paymentOption") === 1 ? get(values, "chequeFees") : 0,
        eftFees:
          get(values, "paymentOption") === 2 ? get(values, "eftFees") : 0,
        loanFeeAmount: get(values, "loanFeeAmount"),
        isDraft: true,
        spousalConsentDocURL: get(values, "spousalConsentDocURL.0.name"),
        promissoryNoteDocURL: get(values, "promissoryNoteDocURL.0.name"),
        loanIdentifier: get(values, "loanIdentifier", null),
      };
      // //main loan save
      // setRequestLoading(true);
      // setAddress(apiData["address"][0]);
      // setBankInformationDetails(apiData["bankInformationDetails"][0]);

      saveInProgressLoanRequest(loanRequestValues, dispatch).then(
        (response) => {
          if (response.isSuccessfull) {
            // dispatch(
            //   setManageTransactionLoanRequestData({
            //     ...values,
            //     loanId: response["loan"]["id"],
            //     address: apiData["address"][0],
            //     bankInformationDetails: apiData["bankInformationDetails"][0],
            //   })
            // );
            // dispatch(
            //   setWithdrawalRequestPageData({
            //     formName: "sourceSplit",
            //     fieldData: sourceSplit,
            //   })
            // );
            var formData = new FormData();
            if (values["promissoryNoteDocURL"])
              formData.append(
                "promissoryNoteDocURL",
                values["promissoryNoteDocURL"][0]
              );

            if (values["spousalConsentDocURL"]) {
              formData.append(
                "spousalConsentDocURL",
                values["spousalConsentDocURL"][0]
              );
            }

            formData.append("loanRequestId", response["loan"]["id"]);
            uploadLoanDocumentsRequest(formData, dispatch).then((response) => {
              if (response.isSuccessfull) {
              }
            });
            // .catch((error) => {
            //   setRequestLoading(false);
            // });
            history.push(
              getAdvancedPathWithParam({
                path: MANAGE_CENSUS_ROUTES.EMPLOYEE_MANAGE_TRANSACTIONS,
                pathParam: [FLOW_TYPES.EDIT, censusId],
              })
            );
          }
        }
      );
    } else {
      if (onRefresh) {
        onRefresh();
      }
    }
  };
  const PreviousButton = () => {
    history.push(
      fromPage == 4
        ? getPathWithParam({
            path: MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST,
            pathParam: [flow, censusId, withdrawalRequestId, fromPage],
          })
        : getPathWithParam({
            path: MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST,
            pathParam: [flow, censusId, withdrawalRequestId, 3],
          })
    );
  };

  return (
    <LoaderWrapper isLoading={dataLoading}>
      <div
        className={`d-flex flex-column manage-mapper-layout h-100 ${
          isLoanSummary ? "layout-height" : ""
        }`}
      >
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center mapper-layout-header">
            <div>
              {donotShowBreadcrumbs ? (
                <></>
              ) : (
                <Breadcrumb>
                  {breadCrumOptions.slice(-4).map((item, index) => (
                    <Breadcrumb.Item key={index}>
                      <Link to={item.link}>{item.label}</Link>
                    </Breadcrumb.Item>
                  ))}
                </Breadcrumb>
              )}
              <h5>{layoutHeader || get(menuDetails, "contentHeader", "")}</h5>
            </div>
            {/* <div className="d-flex align-items-center justify-content-center tab-wrapper">
            {tabs}
          </div> */}
            <div className="ml-auto" style={{ marginRight: "5px" }}>
              <div style={{ display: "flex", flexDirection: "row" }}>
                {isWithdrawalRequest &&
                  //|| isLoanRequest
                  parseInt(fromPage) != 1 && (
                    <div
                      //variant="secondary"
                      onClick={() => CancelButton()}
                      style={{
                        cursor: "pointer",
                        marginRight: "20px",
                        paddingTop: "18px",
                        fontWeight: "500",
                        fontSize: "16px",
                        color: "#307bf6",
                      }}
                    >
                      Save as draft
                    </div>
                  )}
                {isWithdrawalSummary && fromPage != 3 && (
                  <Link
                    //variant="secondary"
                    className="fw-600 ft-16 Light-Blue "
                    onClick={() => PreviousButton()}
                    style={{
                      marginRight: "20px",
                      paddingTop: "18px",
                      fontWeight: "500",
                      fontSize: "16px",
                      color: "#307bf6",
                    }}
                  >
                    Previous
                  </Link>
                )}

                <InnerLayoutButtons
                  menu="mapper"
                  subMenu={
                    menuDetails
                      ? get(menuDetails, "id", "")
                      : "loadDefinitionHome"
                  }
                  buttonsList={buttons}
                  flow={pageFlow}
                />
              </div>

              {showError && (
                <div
                  className={`error-banner justify-content-between d-flex align-items-center ${
                    (showError && "enable") || ""
                  }`}
                >
                  <div>
                    <Image src={Cancel} width="30px" />
                  </div>
                  <div>
                    <div className="error-heading">{errorData.heading}</div>
                    <div className="error-reason">{errorData.reason}</div>
                  </div>
                  <div>
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      color="#000"
                      style={{ fontSize: "14px" }}
                      onClick={() => setShowError(false)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="h-100 overflow-auto">{children}</div>
          <Toast
            onClose={() =>
              dispatch(
                setManageDistributionToastInfo({
                  showToast: false,
                  toastMessage: "",
                })
              )
            }
            show={showToast}
            style={{
              position: "fixed",
              top: "8rem",
              right: "4rem",
              zIndex: "100",
            }}
            delay={3000}
            autohide
          >
            <Toast.Body className="success-toast-align">
              <div className="mr-2">
                {showToast ? (
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    color="#3BB54A"
                    size="lg"
                  />
                ) : (
                  ""
                )}
              </div>
              <div>{toastMessage}</div>
              <div className="ml-2">
                {showToast ? (
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    color="#000000"
                    size="md"
                    onClick={() =>
                      dispatch(
                        setManageDistributionToastInfo({
                          showToast: false,
                          toastMessage: "",
                        })
                      )
                    }
                  />
                ) : (
                  ""
                )}
              </div>
            </Toast.Body>
          </Toast>
          {/* <SaveDraftSection
            isWithdrawalRequest={isWithdrawalRequest}
            when={!isSubmitting && dirty}
            navigate={(path) => history.push(path)}
            onRefresh={onRefresh}
            planId={planId}
            withdrawalId={withdrawalId}
            history={history}
          /> */}
          <RouteLeavingGuard
            when={!isSubmitting && dirty}
            navigate={(path) => history.push(path)}
            onRefresh={onRefresh}
            blockNavigation={blockNavigation}
          />
        </div>
      </div>
    </LoaderWrapper>
  );
};

export default withRouter(ManageDistributionLayout);
